<style scoped>
    .foot {
        padding-top: 20px;
        margin-top: 20px;
    }
</style>
<template>
    <div style="padding: 20px 0;">
        <div style="font-size: 20px;padding: 0 20px;">
            <div v-if="zengpin">选择赠品</div>
            <div v-if="!zengpin">选择物品</div>
        </div>
        <div style="border-top: 1px solid #f1f1f1;border-bottom: 1px solid #f1f1f1;margin-top: 20px;display: flex;">
            <div style="padding: 0 20px;min-height: 200px;min-width: 150px;border-right: 1px solid #f1f1f1;">
                <div v-if="!loadDataTree.length">
                    <div style="padding:14px 16px;font-weight: bold;border-bottom: 1px solid #eaeaea;">按类别筛选</div>
                    <div style="color: #aaa;min-height: 200px;" class="center">
                        <div>暂无数据</div>
                    </div>
                </div>
                <div v-else>
                    <div style="padding:14px 16px;font-weight: bold;border-bottom: 1px solid #eaeaea;">按类别筛选</div>
                    <div style="padding: 5px 16px;max-height: 70vh;overflow: scroll;">
                        <!-- <Tree :data="treeData" @on-check-change="treeSelected" check-strictly show-checkbox expand-node></Tree> -->
                        <Tree :data="treeData" :load-data="loadDataTree" @on-check-change="treeSelected" show-checkbox expand-node></Tree>
                    </div>
                </div>
            </div>
            <div style="width: 100%;overflow: scroll;">
                <div style="padding: 10px;">
                    <Input v-model="query.keywords" icon="ios-search" placeholder="输入名称/编码查询..." style="width: 240px;" @on-enter="keywordsChanged">
                    </Input>
                    <!-- <Checkbox v-model="query.onlyIssued" @on-change="onlyIssuedChanged" style="margin-left: 20px;" v-if="showOnlyIssuedOption">仅显示已下发物品</Checkbox> -->
                    <!-- <Button type="primary" @click="showConditions">按条件筛选</Button> -->
                    <Tag v-if="usedKeywords" closable @on-close="clearKeywords" style="height: 32px;line-height: 32px;margin: 0;">
                        搜索：{{usedKeywords}}</Tag>
                    <Tag v-if="query.relations && query.relations.length" closable @on-close="resetTree" style="height: 32px;line-height: 32px;margin: 0;">
                        仅查看勾选的<span style="color: #20bf64;">{{query.relations.length}}</span>个类别</Tag>
                    <Tag v-if="query.selections" closable @on-close="query.selections=null;loadData()" style="height: 32px;line-height: 32px;margin: 0;">
                        仅查看包含在 <span style="color: #20bf64;">{{querySelectionLength}}</span> 个已选项中的内容</Tag>
                </div>
                <div v-if="wupins.length">
                    <Table :columns="columns1" :loading="loading" :row-class-name="tableRowClass" :data="wupins" @on-select="itemSelected" @on-select-cancel="itemSelectedCancel" @on-select-all="allSelected" @on-select-all-cancel="allSelectedCancel">
                        <!-- 单选 -->
                        <template slot-scope="{row}" slot="radio">
                            <Radio class=" mr-20" :disabled="row._disabled" v-model="row._checked" @on-change="handleSelSingle($event,row)" />
                        </template>
                    </Table>
                    <div>
                        <Page size="small" placement="top" :total="total" :current="page.current" @on-page-size-change="pageSizeChanged" show-sizer :page-size-opts="[10,20,40,100]" :page-size="page.size" @on-change="pageChanged" show-total style="padding: 16px;"></Page>
                    </div>
                </div>
                <div v-if="!wupins.length" class="center" style="color: #aaa;min-height: 200px;">暂无数据</div>
                <div style="padding: 16px 20px;display: flex;align-items: center;" v-if="selectionLength || wupins.length">
                    已选<span style="color: #20bf64;margin: 0 4px;">{{selectionLength}}</span>项
                    <div v-if="selectionLength" style="display: flex;">
                        <div @click="showSelections" style="color: #20bf64;margin-left: 10px;" class="hover">查看</div>
                        <div @click="clearSelections" style="color: #20bf64;margin-left: 10px;" class="hover">取消选择</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="foot jcsb" style="padding: 16px 24px 0 24px;">
            <div>
            </div>
            <div class="center">
                <Button @click="cancel" style="margin-right: 10px;">取消</Button>
                <Button type="primary" @click="wupinSelected">确定</Button>
            </div>
        </div>
    </div>
</template>
<script>
    import CommonService from '@/logics/services/common'
    const commonService = new CommonService()
    export default {
        props: {
            current: Array,
            xieyi: Object,
            xieyitype: String,
            gonghuojigou: Object,
            jigou: Object,
            cangku: Object,
            disables: Array,
            scene: String,
            zengpin: Boolean,
            jiaoyankucun: Boolean,
            caigoudanwei: { // 0 不显示 1显示caigoudanweiStr，2显示多选框
                type: Number,
                default: 0
            },
            /**是否单选 */
            radio: {
                type: Boolean,
                default: false
            },
            /**是否选择商品信息 */
            isMallGoods: {
                type: Boolean,
                default: false
            },
            type: String,
            //是否是协议选择物品（配送、采购），如果是，则会在回显时判断单位是否仍被选中等
            xieyiload: {
                type: Boolean,
                default: false
            },
            fanganload: {
                type: Boolean,
                default: false
            },
            isShangpin: {
                type: Boolean,
                default: false
            },
            skipShangpin: {
                type: Boolean,
                default: false
            },
            initmode: { //多单位初始化模式，moren = 选择默认值,all = 全选，none = 全不选
                type: String,
                default: 'moren'
            },
            wupinquery: Object
        },
        computed: {
            selectionLength() {
                // 不同huozhu的物品，只计算1次
                let codes = []
                for (let item of this.selections) {
                    if (!codes.includes(item.code)) {
                        codes.push(item.code)
                    }
                }
                return codes.length
            },
            querySelectionLength() {
                let codes = []
                for (let item of this.query.selections) {
                    if (!codes.includes(item.code)) {
                        codes.push(item.code)
                    }
                }
                return codes.length
            },
            showOnlyIssuedOption() {
                // 配送申请/审核场景允许按下发状态筛选
                return ['psgh', 'psyh'].includes(this.scene)
            }
        },
        data() {
            return {
                singleGoodsId: null,
                /**单选物品id */
                loading: false,
                cloneSection: [], // 备份一份
                query: {
                    keywords: '',
                    init: true,
                    selections: null,
                    disables: this.disables ? this.disables.map(o => o.code) : null,
                    // onlyIssued: true
                },
                usedKeywords: '',
                page: {
                    current: 1,
                    size: 10,
                },
                total: 0,
                wupins: [],
                columns1: [
                    { type: 'selection', align: 'center', width: 60, },
                    {
                        title: '物品名称',
                        key: 'name',
                        minWidth: 180,
                        render: (h, params) => {
                            if (params.row._disabled) {
                                let disableReason = ''
                                if (params.row.kucunbuzu) {
                                    disableReason = '库存不足'
                                }
                                if (params.row.weixiafa) {
                                    disableReason = '未下发'
                                }
                                if (!params.row.actived) {
                                    if (disableReason) disableReason += ','
                                    disableReason += '未启用'
                                }
                                return h('div', [
                                    h('div', params.row.name),
                                    h('div', { style: { color: 'red' } }, disableReason)
                                ])
                            } else {
                                return h('div', params.row.name)
                            }
                        }
                    },
                    { title: '编码', key: 'code', minWidth: 120 },
                    { title: '规格型号', key: 'guigexinghao', minWidth: 120 },
                    { title: '类别', key: 'leibieStr', minWidth: 100 },
                    {
                        title: '库存单位',
                        key: 'kucundanweiStr',
                        minWidth: 100,
                    },

                    { title: '存储方式', key: 'cunchufangshi', minWidth: 100 },
                ],
                selections: [],
                treeData: [],
                leibies: [],
                zengpins: [],
                feizengpins: [],
            }
        },
        mounted() {
            if (this.xieyiload || this.fanganload) {
                this.selections = this.getSelect(this.current.map(item => { return item }))
            } else {
                this.selections = this.current.map(item => { return item })
            }
            // this.selections = this.current.map(item => { return item })
            this.cloneSection = this.current.map(item => { return item }) //使用map中断引用传递
            // this.$set(this.page, 'size', Number(sessionStorage.pagesize || 10))
            this.loadData()
            this.getTableColumn() // 处理显示表格column
            this._loadData(this.id, (array) => {
                this.treeData = array
            })
        },
        methods: {
            getSelect(arr) {
                let newArr = this.copy(arr)
                for (var i = 0; i < newArr.length - 1; i++) {
                    for (var j = i + 1; j < newArr.length; j++) {
                        if (newArr[i].code === newArr[j].code) {
                            newArr.splice(j, 1);
                            j--;
                        }
                    }
                }
                newArr.forEach(row => {
                    row.selectedCaigoudanweis = []
                    arr.forEach(item => {
                        if (row.code == item.code) {
                            row.selectedCaigoudanweis.push(item.caigoudanweiStr)
                        }
                    })
                    if (row.selectedCaigoudanweis.length == 1) {
                        delete row.selectedCaigoudanweis
                    }
                })
                return newArr
            },
            setTree(list) {
                list.forEach(row => {
                    row.title = row.name
                    //是否有下级
                    if (row.childCount > 0) {
                        row.loading = false
                        row.children = []
                    }
                })
            },
            loadDataTree(item, callback) { //异步加载的方法
                this._loadData(item._id, callback)
            },
            async _loadData(_id, callback) { //发送请求并且对后台的数据进行处理
                let p = { level: 0, withChildCount: true, size: 99999 }
                if (_id) {
                    p = { parentId: _id, withChildCount: true, size: 99999 }
                }
                let res = await commonService.getCategory(p)
                this.setTree(res.leibies)
                callback(res.leibies) //返回新数组
            },
            /**单选 */
            handleSelSingle(v, row) {
                let wupins = [...this.wupins]
                let selections = []
                wupins.map((item) => {
                    if (item._id !== row._id) {
                        item._checked = false
                    } else if (!item._disabled) {
                        item._checked = true
                        selections.push(item)
                    }
                })
                this.selections = selections
            },
            // 处理表格行数据
            getTableColumn() {
                if (this.caigoudanwei) {
                    let unitColumn = {
                        title: '采购单位',
                        key: 'caigoudanweiStr',
                        minWidth: 100,
                        render: (h, params) => {
                            let wupin = params.row
                            if (this.caigoudanwei == 1) {
                                return h('div', wupin.caigoudanweiStr)
                            } else if (wupin.caigoufangshis.length == 1) {
                                return h('div', wupin.caigoufangshis[0].danweiStr)
                            } else {
                                let checkboxs = []
                                for (let caigoufangshi of wupin.caigoufangshis) {
                                    checkboxs.push(h('Checkbox', {
                                        props: {
                                            label: caigoufangshi.danweiStr,
                                        },
                                    }, caigoufangshi.danweiStr))
                                }
                                let group = h('CheckboxGroup', {
                                    style: {
                                        'padding': '10px 0'
                                    },
                                    props: {
                                        value: wupin.selectedCaigoudanweis
                                    },
                                    on: {
                                        'on-change': (value) => {
                                            wupin.selectedCaigoudanweis = value
                                            this.caigoudanweisChanged(value, wupin.code)
                                        }
                                    }
                                }, checkboxs)
                                return group
                            }
                        }
                    }
                    if (!this.caigoudanwei || this.wupins.some(item => (!item.caigoudanweiStr))) {
                        return
                    }
                    let columns = [...this.columns1]
                    columns.splice(columns.length - 1, 0, unitColumn)
                    this.columns1 = columns
                }
                /**单选 */
                if (this.radio) {
                    let columns = [...this.columns1]
                    let radioColumn = {
                        slot: 'radio',
                        width: 30,
                        title: " "
                    }
                    columns.splice(0, 1, radioColumn)
                    this.columns1 = columns
                }
            },
            // 切换物品采购单位-处理默认值
            caigoudanweisChanged(value, code) {
                let item = this.selections.findOne({ code: code })
                let wupin = this.wupins.findOne({ code: code })
                if (!item) {
                    item = wupin
                } else {
                    item.caigoufangshis = wupin.caigoufangshis
                }
                item.selectedCaigoudanweis = value
            },
            tableRowClass(row,) {
                if (row._disabled) {
                    return 'disabled'
                } else {
                    return ''
                }
            },
            clearTreeChecks() {
                for (let node of this.treeData) {
                    node.checked = false
                    this.clearNode(node)
                }
            },
            clearNode(node) {
                if (node.children) {
                    for (let child of node.children) {
                        child.checked = false
                        this.clearNode(child)
                    }
                }
            },
            resetTree() {
                this.query.relations = null
                this.clearTreeChecks()
                this.loadData()
            },
            // treeClicked(nodes) {
            //     let that = this
            //     if (nodes.length) {
            //         that.query.relation = { _id: nodes[0]._id, name: nodes[0].name }
            //     } else {
            //         that.query.relation = null
            //     }
            //     that.loadData()
            // },
            treeSelected(nodes) {
                this.query.relations = nodes.map((item) => { return { _id: item._id, name: item.name } })
                // this.parseNode(current)
                for (let node of nodes) {
                    this.parseNode(node)
                }
                this.loadData()
            },
            parseNode() {
                // if (node.checked && node.children) {
                //     for (let child of node.children) {
                //         if (!child.checked) {
                //             child.checked = true
                //             this.query.relations.push({ _id: child._id, name: child.name })
                //             this.parseNode(child)
                //         }
                //     }
                // }
            },
            clearKeywords() {
                this.query.keywords = ''
                this.usedKeywords = ''
                this.loadData()
            },
            keywordsChanged() {
                this.usedKeywords = this.query.keywords
                this.page.current = 1
                this.loadData()
            },
            onlyIssuedChanged() {
                this.page.current = 1
                this.loadData()
            },
            pageChanged(value) {
                this.page.current = value
                this.loadData()
            },
            pageSizeChanged(value) {
                this.page.size = value
                // sessionStorage.pagesize = value
                if (this.page.current == 1) {
                    setTimeout(() => {
                        this.loadData()
                    }, 30);
                }
            },
            loadData() {
                let that = this
                that.loading = true
                that.wupins = []
                that.$api.post('/web/main/wupinselector/load?V=2', {
                    type: this.type,
                    query: this.query,
                    page: this.page,
                    xieyiId: this.xieyi ? this.xieyi._id : null,
                    xieyitype: this.xieyitype,
                    jigouId: this.jigou ? this.jigou._id : null,
                    jigouType: this.jigou ? this.jigou.type : null,
                    gonghuojigouId: this.gonghuojigou ? this.gonghuojigou._id : null,
                    gonghuojigouCode: this.gonghuojigou ? this.gonghuojigou.code : null,
                    cangkuId: this.cangku ? this.cangku._id : null,
                    shangpincheck: this.isMallGoods,
                    isShangpin: this.isShangpin,
                    wupinquery: this.wupinquery,
                    jiaoyankucun: this.jiaoyankucun,
                }).then(res => {
                    that.loading = false
                    that.total = res.data.total
                    that.usedKeywords = that.query.keywords
                    let wupins = res.data.wupins

                    this.selections.forEach((item, index) => {
                        item._index = index
                    })
                    if (that.query.init) {
                        that.query.init = false
                        if (this.zengpin) {
                            this.feizengpins = this.selections.filter(o => !o.zengpin)
                            this.selections = this.selections.filter(o => o.zengpin)
                        } else {
                            this.zengpins = this.selections.filter(o => o.zengpin)
                            this.selections = this.selections.filter(o => !o.zengpin)
                        }
                    }
                    if (this.caigoudanwei == 2) {
                        // this.selections = this.selections.unique('code')
                        // console.log('this.selections', this.selections.map(o => `${o.name}(${o.caigoudanweiStr})`))
                        let selections = []
                        for (let selection of this.selections) {
                            let item = selections.find(o => o.code == selection.code)
                            if (!item) {
                                item = selection
                                item._selectedCaigoudanweis = item._selectedCaigoudanweis || []
                                item._caigoufangshis = item._caigoufangshis || []
                                selections.push(item)
                            }

                            if (selection.caigoudanweiStr && !item._selectedCaigoudanweis.includes(selection.caigoudanweiStr)) {
                                // console.log(`${selection.name} ${selection.caigoudanweiStr}`)
                                item._selectedCaigoudanweis.push(selection.caigoudanweiStr)
                                item._caigoufangshis.push(selection.caigoufangshi)
                            }
                        }
                        this.selections = selections
                        // console.log('this.selections', selections.map(o => `${o.name}(${o._selectedCaigoudanweis})`))
                        for (let s of this.selections) {
                            if (!s.caigoufangshis) {
                                let wupin = wupins.findOne({ code: s.code })
                                if (wupin && wupin.caigoufangshis) {
                                    s.caigoufangshis = wupin.caigoufangshis
                                }
                            }
                        }
                    }
                    for (let wupin of wupins) {
                        let found = null
                        if (wupin.caigoudanweiStr) {
                            found = that.selections.findOne({ 'code': wupin.code, 'caigoudanweiStr': wupin.caigoudanweiStr })
                        } else {
                            found = that.selections.findOne({ 'code': wupin.code })
                        }
                        if (this.caigoudanwei) {
                            wupin.selectedCaigoudanweis = this.getWupinCaigoudanweis(wupin) // 处理采购方式数组
                            let s = this.selections.findOne({ code: wupin.code })
                            if (s && s.selectedCaigoudanweis) wupin.selectedCaigoudanweis = s.selectedCaigoudanweis
                            if (s && !s.selectedCaigoudanweis) s.selectedCaigoudanweis = wupin.selectedCaigoudanweis
                        }
                        if (found) {
                            wupin._checked = true
                        }
                        if (this.jiaoyankucun && Number(wupin.keyongshuliang).toFixed(0) <= 0 && wupin.kucunbuxian == false) {
                            wupin.kucunbuzu = true
                        }
                        if (wupin.actived == false || wupin.weixiafa || wupin.kucunbuzu) {
                            wupin._disabled = true
                        }
                        if (this.skipShangpin && wupin.shangpin && Object.keys(wupin.shangpin).length) {
                            wupin._disabled = true
                        }
                        /**单选 */
                        if (this.radio) {
                            if (this.selections.length && wupin._id === this.selections[0]._id) {
                                wupin._checked = true
                            }
                        }
                    }
                    that.wupins = wupins
                }, () => {
                    that.loading = false
                })
            },

            // 处理采购方式数组
            getWupinCaigoudanweis(wupin) {
                let selectedCaigoudanweis = []
                let currentWupins = this.cloneSection.findAll({ code: wupin.code })
                for (const i of wupin.caigoufangshis) {
                    if (currentWupins.length) {
                        let danweiMatched = false
                        for (const j of currentWupins) {
                            if (!j.caigoudanweiStr || i.danweiStr == j.caigoudanweiStr) {
                                danweiMatched = true
                            }
                        }
                        if (danweiMatched) selectedCaigoudanweis.push(i.danweiStr)
                    } else {
                        if (this.initmode == 'moren') {
                            if (i.moren) {
                                selectedCaigoudanweis.push(i.danweiStr)
                            }
                        } else if (this.initmode == 'all') {
                            selectedCaigoudanweis.push(i.danweiStr)
                        } else if (this.initmode == 'none') {
                            //
                        }
                    }
                }
                selectedCaigoudanweis = Array.from(new Set(selectedCaigoudanweis))
                return selectedCaigoudanweis
            },

            parseTree(leibies) {
                let treeData = []
                let maxlevel = 0
                let items = []
                for (let leibie of leibies) {
                    if (leibie.level > maxlevel) {
                        maxlevel = leibie.level
                    }
                    items.push({ _id: leibie._id, name: leibie.name, level: leibie.level, parent: leibie.parent, title: leibie.name, checked: false, expand: true, children: [], })
                }
                let level = maxlevel
                while (level >= 0) {
                    for (let item of items) {
                        if (item.level == level) {
                            if (!item.parent) {
                                treeData.push(item)
                            } else {
                                for (let parent of items) {
                                    if (parent._id == item.parent._id) {
                                        parent.children.push(item)
                                    }
                                }
                            }
                        }
                    }
                    level--
                }
                // for (let item of items) {
                //     let allchildren = this.getAllChildren(item)
                //     if (allchildren.some(o => o.checked) && allchildren.some(o => !o.checked)) {
                //         item.expand = true
                //     } else {
                //         item.expand = false
                //     }
                // }
                this.treeData = treeData
            },
            search() {
                this.loadData()
            },
            cancel() {
                this.$emit('cancel')
            },
            wupinSelected() {
                let selections = this.getSelectionsWupins()
                if (this.zengpin) {
                    selections.forEach((item) => {
                        item.zengpin = true
                    })
                    selections = selections.concat(this.feizengpins)
                } else {
                    selections = selections.concat(this.zengpins)
                }
                //sort
                selections.sort((a, b) => {
                    return a._index - b._index
                })
                for (let selection of selections) {
                    delete selection.selectedCaigoudanweis
                    delete selection._selectedCaigoudanweis
                }
                this.$emit('wupinSelected', selections)
            },

            // 获取选中物品
            getSelectionsWupins() {
                let newSelections = []
                if (this.caigoudanwei == 0 || this.caigoudanwei == 1) {
                    return this.selections
                }
                for (const i of this.selections) {
                    if (i.selectedCaigoudanweis && i.selectedCaigoudanweis.length) {
                        i.selectedCaigoudanweis.map((item) => {
                            let caigoufangshi = i.caigoufangshis.findOne({ danweiStr: item })
                            if (caigoufangshi) {
                                let cloneItem = { ...i }
                                delete cloneItem._selectedCaigoudanweis
                                delete cloneItem._caigoufangshis
                                cloneItem.caigoudanweiStr = item
                                cloneItem.caigoufangshi = caigoufangshi
                                newSelections.push(cloneItem)
                            }
                        })
                    } else if (i._selectedCaigoudanweis && i._selectedCaigoudanweis.length) {
                        i._selectedCaigoudanweis.map((item) => {
                            let caigoufangshi = i._caigoufangshis.findOne({ danweiStr: item })
                            if (caigoufangshi) {
                                let cloneItem = { ...i }
                                delete cloneItem._selectedCaigoudanweis
                                delete cloneItem._caigoufangshis
                                cloneItem.caigoudanweiStr = item
                                cloneItem.caigoufangshi = caigoufangshi
                                newSelections.push(cloneItem)
                            }
                        })
                    } else {
                        if (this.caigoudanwei > 0) {
                            if (!i.caigoufangshi && Array.isArray(i.caigoufangshis) && i.caigoufangshis.length === 1) {
                                i.caigoufangshi = i.caigoufangshis[0]
                            }
                            if (!i.caigoudanweiStr && i.caigoufangshi) {
                                i.caigoudanweiStr = i.caigoufangshi.danweiStr
                            }
                        }
                        newSelections.push(i)
                    }
                }
                return newSelections
            },

            showSelections() {
                this.query = { selections: this.selections.map(item => { return { _id: item._id, code: item.code } }) }
                this.page.current = 1
                this.clearTreeChecks()
                this.loadData()
            },
            clearSelections() {
                this.selections = []
                let wupins = []
                for (let item of this.wupins) {
                    item._checked = false
                    wupins.push(item)
                }
                this.wupins = wupins
            },
            allSelected(items) {
                for (let item of items) {
                    if (item.caigoudanweiStr) {
                        if (!this.selections.findOne({ code: item.code, caigoudanweiStr: item.caigoudanweiStr })) {
                            this.selections.push(item)
                        }
                    } else {
                        if (!this.selections.findOne({ code: item.code })) {
                            this.selections.push(item)
                        }
                    }
                }
            },
            allSelectedCancel() {
                for (let item of this.wupins) {
                    this.selections.remove({ code: item.code })
                }
            },
            itemSelected(_, item) {
                this.selections.push(item)
            },
            itemSelectedCancel(_, item) {
                if (item.caigoudanweiStr) {
                    this.selections.remove({ code: item.code, caigoudanweiStr: item.caigoudanweiStr })
                } else {
                    this.selections.remove({ code: item.code })
                }
            },

        },
    };
</script>



// WEBPACK FOOTER //
// src/components/common/WupinSelector.vue?5ed5985a